import { createTopic } from "../../utils/topic-utils";
import decorators from "./decorators";

const user = {
  state: {},
  properties: [
    {
      id: "language",
      type: "Select",
      defaultValue: "global",
      options: [
        { value: "global", label: "EN" },
        { value: "fi-FI", label: "FI" },
        { value: "fr-FR", label: "FR" },
        { value: "de-DE", label: "DE" },
        { value: "pl-PL", label: "PL" },
        { value: "it-IT", label: "IT" },
        { value: "es-ES", label: "ES" },
        { value: "da-DK", label: "DK" },
        { value: "se-SE", label: "SE" },
        { value: "no-NO", label: "NO" },
        { value: "pt-PT", label: "PT" },
        { value: "ru-RU", label: "RU" },
        { value: "nl-NL", label: "NL" },
      ],
    },
  ],
};

const tractor = {
  state: {},
  properties: [
    {
      id: "playing",
      type: "Boolean",
      defaultValue: false,
    },
    {
      id: "type",
      type: "Select",
      defaultValue: "A115",
      valueType: "String",
      options: [
        {
          value: "A115",
          label: "type-hitech-4",
          description: {
            title: "type-hitech-4-title",
            subtitle: "type-hitech-4-subtitle",
            body: "type-hitech-4-body",
          },
        },
        {
          value: "A85",
          label: "type-hitech",
          description: {
            title: "type-hitech-title",
            subtitle: "type-hitech-subtitle",
            body: "type-hitech-body",
          },
        },
      ],

      // A85 (HT2) has only red color --> disable color topic & force red color
      decorator: decorators.decorateType
    },
    {
      id: "color",
      type: "Select",
      valueType: "Color",
      defaultValue: "red-metallic",
      options: [
        "black-metallic",
        "blue-metallic",
        "bronze-metallic",
        "olive-green-metallic",
        "red",
        "red-metallic",
        "white-metallic",
      ],
    },
    {
      id: "view",
      type: "Select",
      defaultValue: "exterior",
      options: [
        {
          value: "exterior",
          label: "Exterior",
          parent: null,
          camera: { position: [5, 1.5, -2], target: [1.1, 0.55, 0] },
        },
        {
          value: "interior",
          label: "Interior",
          parent: "exterior",
          camera: { position: [0.2, 1.5, 0], target: [0.3, 1.48, 0] },
        },
      ],
    },
    {
      id: "loader",
      type: "Boolean",
      defaultValue: false,
    },
    {
      id: "forestTank",
      label: "forest-tank-label",
      type: "Boolean",
      defaultValue: false,
    },
    {
      id: "flareExtensions",
      label: "flare-extensions-label",
      type: "Boolean",
      defaultValue: false,
    },
    {
      id: "loaderPosition",
      label: "loader-position-label",
      type: "Number",
      defaultValue: 0,
      min: 0,
      max: 0.6666666865348816,
      step: 0.01,
    },
     {
      id: "doorOpen",
      type: "Boolean",
      defaultValue: false,
    }, 
    {
      id: "Sunvisor",
      type: "Boolean",
      defaultValue: false,
    },
    {
      id: "frontLinkage",
      //label: "front-linkage-label",
      type: "Boolean",
      defaultValue: false,
    }, 
    {
      id: "frontLinkage_up",
      //label: "front-linkage-label",
      type: "Boolean",
      defaultValue: false,
    }, 
    {
      id: "frontLinkageWorkDrive",
      type: "Boolean",
      defaultValue: false,
    }, 
    {
      id: "StrairsDown",
      type: "Boolean",
      defaultValue: true,
    }, 
/*      {
      id: "doorOpen_L",
      type: "Boolean",
      defaultValue: false,
    }, 
     {
      id: "doorOpen_R",
      type: "Boolean",
      defaultValue: true,
    },  */
    {
      id: "steeringAngle",
      label: "steering-angle-label",
      type: "Number",
      defaultValue: 0.6666666865348816 / 2,
      min: 0,
      max: 0.6666666865348816,
      step: 0.001,
    },
    {
      id: "environment",
      type: "Select",
      valueType: "String",
      defaultValue: "field",
      options: [
        {
          value: "field",
          label: "environment-field",
        },
        {
          value: "showroom",
          label: "environment-showroom",
        },
      ],
    },
    {
      id: "topic",
      type: "Select",
      defaultValue: null,
      options: [
        {
          value: "type",
          label: "type",
          icon: "icon-type",
          view: "exterior",
          properties: ["type"],
        },
        {
          value: "color",
          label: "color",
          icon: "icon-colour",
          view: "exterior",
          properties: ["color"],
        },
        {
          value: "loader",
          label: "loader",
          icon: "icon-loader",
          view: "exterior",
          properties: ["loader", "loaderPosition"],
          description: {
            title: "loader-title",
            subtitle: "loader-subtitle",
            body: "loader-body",
          },
        },
        // 16x16 Forest tank hitech4
        {
          value: "forestTank",
          label: "forest-tank",
          icon: "icon-forest-tank",
          view: "exterior",
          properties: ["forestTank"],
          description: {
            title: "forest-tank-title",
            subtitle: "forest-tank-subtitle",
            body: "forest-tank-body",
          },
        },
        {
          value: "frontLinkage",
          label: "front-linkage",
          icon: "icon-front-linkage",
          view: "exterior",
          properties: ["frontLinkage"],
          description: {
            title: "front-linkage-title",
            subtitle: "front-linkage-subtitle",
            body: "front-linkage-body",
          },
        },

        {
          value: "flareExtensions",
          label: "flare-extensions",
          icon: "icon-flare-extensions",
          view: "exterior",
          properties: ["flareExtensions"],
          description: {
            title: "flare-extensions-title",
            subtitle: "flare-extensions-subtitle",
            body: "flare-extensions-body",
          },
        },
        {
          value: "steeringAngle",
          label: "steering-angle",
          icon: "icon-steering-angle",
          properties: ["steeringAngle"],
          description: {
            title: "steering-angle-title",
            subtitle: "steering-angle-subtitle",
            body: "steering-angle-body",
          },
        },
        {
          value: "environment",
          label: "environment",
          icon: "icon-environment",
          properties: ["environment"],
          description: {
            title: "environment-title",
            subtitle: "environment-subtitle",
            body: "environment-body",
          },
        },

        createTopic("content-1"),
        createTopic("content-2"),
        createTopic("content-3"),
        createTopic("content-4"),
        createTopic("content-5"),
        createTopic("content-6"),
        createTopic("content-7"),
        createTopic("content-8"),
        createTopic("content-9"),
        createTopic("content-10"),
        createTopic("content-11"),
        createTopic("content-12"),
        createTopic("content-13"),
        createTopic("content-14"),
        createTopic("content-15"),
        createTopic("content-16"),
        createTopic("content-A"),
        createTopic("content-B"),
        createTopic("content-C"),
        createTopic("content-D"),
        createTopic("content-E"),
        createTopic("content-F"),
        createTopic("content-G1"),
        createTopic("content-G2"),
        createTopic("content-G3-HT"),
        createTopic("content-G3-HT4"),
        createTopic("content-G4"),
        createTopic("content-G5"),
        createTopic("content-H"),
        createTopic("content-I"),
        createTopic("content-J"),
      ],
    },
  ],
};

export default { user, tractor };
